import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { Supervisor } from 'service';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import ArthaGateway from 'service/ArthaGateway';
import moment from 'moment';
import { get } from 'http';
import { useLocation } from 'react-router';

export const ReportView = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [supervisor, setSupervisor] = useState<Supervisor>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [productions, setProductions] = useState<any[]>([]);
    const [durationId, setDurationId] = useState<string>("0");
    const [from, setFrom] = useState<string>(moment().format("YYYY-MM-DD"));
    const [to, setTo] = useState<string>(moment().format("YYYY-MM-DD"));
    const [brandId, setBrandId] = useState<number>(0);
    const [groupId, setGroupId] = useState<number>(0);
    const [masterId, setMasterId] = useState<number>(0);
    const [productionStages, setProductionStages] = useState<any[]>([]);
    const [supervisorName, setSupervisorName] = useState<string>("");
    const [supervisors, setSupervisors] = useState<Supervisor[]>([]);
    const [applicableSupervisors, setApplicableSupervisors] = useState<Supervisor[]>([]);
    const [stageId, setStageId] = useState<number>(2);
    const [supervisorId, setSupervisorId] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(1000);
    const [totalPages, setTotalPages] = useState<number>(5);
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setDurationId(params.get("d") ?? "0");
        setBrandId(parseInt(params.get("b") ?? "0"));
        setGroupId(parseInt(params.get("g") ?? "0"));
        setMasterId(parseInt(params.get("m") ?? "0"));
        setStageId(parseInt(params.get("s") ?? "0"));
        setSupervisorId(parseInt(params.get("su") ?? "0"));
        setPageNumber(1);
    }, [location.search]);

    useEffect(() => {
        loadProductions();
    }, [pageNumber, supervisorId]);

    useEffect(() => {
        let applicableSup: Supervisor[] = [];
        supervisors.forEach((sup) => {
            if (sup && sup.stages.includes(stageId)) {
                applicableSup.push(sup);
            }
        });
        setApplicableSupervisors(applicableSup);
    }, [supervisors, stageId]);

    useEffect(() => {
        if (user.profile) {
            setSupervisor(user.profile.profile);
            let stages = [
                { id: 2, name: 'Cutting', isActive: true },
                { id: 5, name: 'Loading', isActive: true },
                { id: 6, name: 'Stiching', isActive: true },
                { id: 8, name: 'Kaja Button', isActive: true },
                { id: 9, name: 'Trimming', isActive: true },
                { id: 10, name: 'Ironing', isActive: true },
                { id: 12, name: 'Packing', isActive: true }
            ]
            setProductionStages(stages);
            loadSupervisors();
            setIsLoading(false);
        }
    }, [user]);
    
    const loadSupervisors = () => {
        let cacheData = sessionStorage.getItem('SUPERVISORS_CACHE');
        if (cacheData && cacheData.length > 0) {
            let supervisorsData = JSON.parse(cacheData);
            setSupervisors(supervisorsData);
        }
        ArthaGateway.loadSupervisors().then((data) => {
            setSupervisors(data);
            sessionStorage.setItem('SUPERVISORS_CACHE', JSON.stringify(data));
        });
    }

    function loadProductions(): void {
        if(pageNumber <= 0) return;

        setIsLoading(true);
        setProductions([]);
        ArthaGateway.getProductions(durationId, from, to, brandId, groupId, masterId, stageId, supervisorId, null, pageNumber, pageSize).then((data) => {
            data.entries.map((production) => production.isExpanded = false);
            if (pageNumber == 1) {
                setProductions(data.entries);
            }
            else {
                setProductions([...productions, ...data.entries]);
            }
            setTotalPages(data.totalPages);
            setIsLoading(false);
        });
    }

    function getDurationName(): string {
        switch (durationId) {
            case "0": return moment().format("DD/MMM/YYYY");
            case "1": return moment().subtract(1, 'days').format("DD/MMM/YYYY");
            case "2": return `Week of ${moment().startOf('week').format("DD/MMM/YYYY")} - ${moment().endOf('week').format("DD/MMM/YYYY")}`;
            case "3": return `Week of ${moment().subtract(1, 'weeks').startOf('week').format("DD/MMM/YYYY")} - ${moment().subtract(1, 'weeks').endOf('week').format("DD/MMM/YYYY")}`;
            case "4": return `Month of ${moment().startOf('month').format("DD/MMM/YYYY")} - ${moment().endOf('month').format("DD/MMM/YYYY")}`;
            case "5": return `Month of ${moment().subtract(1, 'months').startOf('month').format("DD/MMM/YYYY")} - ${moment().subtract(1, 'months').endOf('month').format("DD/MMM/YYYY")}`;
            case "6": return `Last 2 Month`;
            case "7": return `Last 3 Month`;
            case "8": return `Last Year`;
            case "9": return `Last 1 Year`;
            default: return `${moment(from).format("DD/MMM/YYYY")} to ${moment(to).format("DD/MMM/YYYY")}`;
        }
    }

    function getSupervisorSummary(data: any[]): Record<string, number> {
        return data.reduce((summary, item) => {
            const name = item.supervisorName;
            const qty: number = item.quantity || 0;

            if (!summary[name]) {
                summary[name] = 0;
            }
            summary[name] += qty;

            return summary;
        }, {} as Record<string, number>);
    }

    return (
        <>
            <div className="page-reports">
                <div className='row'>
                    <div className='col-6 col-md-4'>
                        <div className="form-group">
                            <label>Duration</label>
                            <select className="form-control" id="duration" value={durationId} onChange={(e) => setDurationId(e.target.value)} disabled>
                                <option value="2024">FY 2024-2025</option>
                                <option value="2023">FY 2023-2024</option>
                                <option value="2022">FY 2022-2023</option>
                                <option value="2021">FY 2021-2022</option>
                                <option value="2020">FY 2020-2021</option>
                                <option value="2019">FY 2019-2020</option>
                                <option value="2018">FY 2018-2019</option>
                                <option value="0">Today</option>
                                <option value="1">Yesterday</option>
                                <option value="2">This Week</option>
                                <option value="3">Last Week</option>
                                <option value="4">This Month</option>
                                <option value="5">Last Month</option>
                                <option value="6">Last 2 Month</option>
                                <option value="7">Last 3 Month</option>
                                <option value="8">Last Year</option>
                                <option value="9">Last 1 Year</option>
                            </select>
                        </div>
                    </div>

                    <div className='col-6 col-md-4'>
                        <div className="form-group">
                            <label>Stage</label>
                            <select className="form-control" id="duration" value={stageId} onChange={(e) => setStageId(parseInt(e.target.value))} disabled>
                                {productionStages.map((stage) => (
                                    <option key={stage.id} value={stage.id}>{stage.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-6 col-md-4'>
                        <div className="form-group">
                            <label>Supervisor</label>
                            <select className="form-control" id="supervisor" value={supervisorId} onChange={(e) => setSupervisorId(parseInt(e.target.value))}>
                                <option value="0">All</option>
                                {applicableSupervisors.map((supervisor) => (
                                    <option key={supervisor.id} value={supervisor.id}>{supervisor.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="ui-divider" />
                <div className="list-group mt-2 mb-2">
                    {productions && productions.map((jo) => (
                        <div key={jo.jobId} className='list-group-item list-group-item-action'>
                            <div className='float-start'>
                                <b>{jo.jobOrderNumber}</b>
                                <div>{jo.master}</div>
                                <div>{jo.supervisorName}</div>
                                <div>{moment(jo.date).format("DD/MMM/YYYY")}</div>
                            </div>
                            <div className="float-end fw-bold" style={{ fontSize: '1.8rem' }}>{jo.quantity.toLocaleString()}</div>
                        </div>
                    ))}
                    <div className='list-group-item bg-dark text-light'>
                        <div className='float-start'>
                            Total
                        </div>
                        <div className="float-end fw-bold " style={{ fontSize: '1.8rem' }}>
                            {productions.reduce((acc, curr) => acc + curr.quantity, 0).toLocaleString()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};